var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 58",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#1da1f2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 925",
    d: "M14.465 26.635a12.064 12.064 0 0 0 12.146-12.146c0-.186 0-.372-.009-.549a8.746 8.746 0 0 0 2.133-2.213 8.664 8.664 0 0 1-2.452.673 4.266 4.266 0 0 0 1.877-2.364 8.644 8.644 0 0 1-2.709 1.036 4.271 4.271 0 0 0-7.383 2.921 3.912 3.912 0 0 0 .115.974 12.11 12.11 0 0 1-8.8-4.462 4.267 4.267 0 0 0 1.328 5.692 4.193 4.193 0 0 1-1.93-.531v.053a4.273 4.273 0 0 0 3.426 4.187 4.255 4.255 0 0 1-1.124.15 4.075 4.075 0 0 1-.806-.08 4.262 4.262 0 0 0 3.984 2.966 8.581 8.581 0 0 1-5.3 1.824 7.765 7.765 0 0 1-1.018-.062 11.893 11.893 0 0 0 6.524 1.93",
    fill: "#fff"
  })));
};

export default SvgTwitter;